import { updateCartTotals, validateBasket } from './cartCustomService';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var cartCustomService = require('./cartCustomService');
var validator = require('../validator');
var giftOptionsErrorMessages = {};
var populateErrorMessages = require('../validationMessage');
const utils = require('../utils');
var DOMPurify = require('dompurify');
/**
* Handle Gift Options Validation
*/
function giftOptionsValidation() {
    var $form = $('.gift-option-form');
    var $sendNoteTo = $form.find('#sendNoteTo');
    var $sendNoteFrom = $form.find('#sendNoteFrom');
    populateErrorMessages(giftOptionsErrorMessages, $sendNoteTo);
    populateErrorMessages(giftOptionsErrorMessages, $sendNoteFrom);
    validator.init($form, {
        ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
        ...validator.ENABLED_BUTTON_SETTINGS,
        messages: giftOptionsErrorMessages
    });
}
/**
 * Checks data before giftbox form submit
 @param {Object} res - response from Ajax call on form submit
 */
function handleSubmitCheck(res) {
    let includeGiftNoteEnabled = res.includeGiftNote;
    let sendInGiftBoxEnabled = res.sendInGiftBox;
    if (sendInGiftBoxEnabled) {
        $('.sendInGiftBox').removeClass('d-none');
        $('.sendInGiftOptions').addClass('d-none');
        $('.sendInGiftOptions').removeClass('d-inline');
    } else {
        $('.sendInGiftBox').addClass('d-none');
        $('.sendInGiftOptions').removeClass('d-none');
        $('.sendInGiftBox').removeClass('d-inline');
    }
    if (sendInGiftBoxEnabled && includeGiftNoteEnabled) {
        $('.gift__card .row-feature').removeClass('gift_note-hidden');
        $('.gift__card').removeClass('d-none');
    } else if (includeGiftNoteEnabled) {
        $('.gift__card .gift-image').addClass('d-none');
        $('.gift__card .row-feature').removeClass('gift_note-hidden');
        $('.gift__card').removeClass('d-none');
    } else {
        $('.gift__card .row-feature').addClass('gift_note-hidden');
        $('.gift__card').removeClass('d-none');
        return;
    }
}

/**
 * Validate if empty input before giftbox form submit
 @param {boolean} sendInGiftBox - giftbox enabled condition
 @param {boolean} sendInGiftNote - giftnote enabled condition
 @returns {boolean} - giftnote input is not empty
 */
function inputGiftNoteCheck(sendInGiftBox, sendInGiftNote) {
    var giftNoteForm = $('.gift-box--note');
    var to = $(giftNoteForm).find('#sendNoteTo');
    var from = $(giftNoteForm).find('#sendNoteFrom');
    var giftMsg = $(giftNoteForm).find('.sendNoteMessage');
    to.val(utils.removeEmoji(to.val()).trim());
    from.val(utils.removeEmoji(from.val()).trim());
    giftMsg.val(utils.removeEmoji(giftMsg.val()).trim());
    if (!sendInGiftBox && !sendInGiftNote) {
        $('.gift__card .gift-image').addClass('d-none');
        return true;
    }
    $('.gift_to span').text(to.val());
    $('.gift_from span').text(from.val());
    $('.gift_message span').text(`${giftMsg.val()}`);
    $('.gift-box--note .gift-input-box').removeClass('gift-error-indicator');
    $('.gift-box--note .gift-error-msg').addClass('d-none');
    return true;
}


/**
 *
 @param {Object} response - response from Ajax call on edit
 Validate checked / unchecked in Edit flow
 */
function handleEditCheck(response) {
    let includeGiftNoteEnabled = response.includeGiftNote;
    let sendInGiftBoxEnabled = response.sendInGiftBox;
    if (sendInGiftBoxEnabled || includeGiftNoteEnabled) {
        if (sendInGiftBoxEnabled && includeGiftNoteEnabled) {
            $('#sendGiftBox').prop('checked', sendInGiftBoxEnabled);
            $('#giftNoteCheck').prop('checked', includeGiftNoteEnabled);
        } else if (includeGiftNoteEnabled) {
            $('#sendGiftBox').prop('checked', sendInGiftBoxEnabled);
            $('#giftNoteCheck').prop('checked', includeGiftNoteEnabled);
        }
        $('#sendGiftBox').prop('checked', sendInGiftBoxEnabled);
        $('#giftNoteCheck').prop('checked', includeGiftNoteEnabled);
    }
    if (response.hidePrice) {
        $('#hidePricePackaging').prop('checked', response.hidePrice);
    }
    $('.sendNoteTo, .sendNoteFrom, .sendNoteMessage').val('');
    $('#buttonGiftUpdate').prop('disabled', false);
}
/**
 *
 @param {Object} $this - this object
 @param {Object} parent - parent object
 Validate checked / unchecked of gift note
 */
function checkGiftNote($this, parent) {
    let $giftToFromElem = $('input#sendNoteTo, input#sendNoteFrom');
    if ($this.is(':checked')) {
        $('.gift-box--note').removeClass('d-none');
        $('.primary__button--dark.btn-git-box-submit').removeClass('d-none');
        $giftToFromElem.attr('required', true);
        parent.validateHidePriceOption();
        parent.updateGiftButton(false);
        return;
    }
    if ($('.send-gift-box').is(':checked')) {
        $giftToFromElem.attr('required', false);
        $('.gift-box--note').addClass('d-none');
        parent.updateGiftButton(false);
        parent.validateHidePriceOption();
        return;
    }
    $('.gift-box--form').find('#sendNoteTo').focus();
    $('.gift-box--note').addClass('d-none');
    $('.primary__button--dark.btn-git-box-submit').addClass('d-none');
    parent.updateGiftButton(true);
    parent.validateHidePriceOption();
}
/**
 *
 update Button on clicking select boxes
 */
function updateButton() {
    if ($('.gift-box').find('.gift-input:checked').length > 0) {
        $('.primary__button--dark.btn-git-box-submit').removeClass('d-none');
    } else {
        $('.primary__button--dark.btn-git-box-submit').addClass('d-none');
    }
}

export default class GiftCard {

    constructor() {
        // this.onEnabledGiftBoxOption();
        this.parent = this;
        this.toggleGiftBox();
        this.onClickGiftNote();
        this.onClickSendGiftBox();
        this.onHidePrice();
        this.updateGiftButton();
        this.onChangeFormInputValue();
        this.giftFormOnSubmit();
        this.validateHidePriceOption();
        this.onEditGidtCard();
        this.onRemoveGiftCard();
    }

    updateGiftButton(isDisabled = true) {
        $('#buttonGiftUpdate').prop('disabled', isDisabled);
    }

    onHidePrice() {
        const parent = this;
        $(document).on('change', '#hidePricePackaging', function () {
            if (this.checked) {
                parent.updateGiftButton(false);
                updateButton();
                return;
            }
            updateButton();
            parent.updateGiftButton(true);
            parent.validateHidePriceOption();
            return;
        });
    }

    validateHidePriceOption() {
        const parent = this;
        const sendPriceBox = $('#sendGiftBox').is(':checked');
        const sendGiftNote = $('.giftNoteCheck').is(':checked');
        const hidePrice = $('#hidePricePackaging').is(':checked');
        $('#hidePricePackaging').prop('checked', hidePrice);
        if (!hidePrice & !sendPriceBox && !sendGiftNote) {
            parent.updateGiftButton(true);
            return;
        }
        parent.updateGiftButton(false);
        return;
    }

    onEnabledCheckBoxValue(isChecked = false) {
        $('#hidePricePackaging').prop('checked', isChecked);
        $('#giftNoteCheck').prop('checked', isChecked);
    }

    toggleGiftBox() {
        $('body').on('click', '.gift-box .gift-box--header', function () {
            $('.gift-icon-add').toggleClass('d-none');
            $('.gift-icon-remove').toggleClass('d-none');
            let open = true;
            if ($('.gift-icon-add').hasClass('d-none')) {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
                open = false;
            }
            $('.gift-box--form').slideToggle(open ? 300 : 200, function () {
                if ($('.gift-box--form').hasClass('d-none')) {
                    $('.gift-box--form').removeClass('d-none');
                    $('.gift-box--form').css('display', 'flex');
                    return;
                }
                return;
            });
        });
    }
    onClickGiftNote() {
        const parent = this;
        $(document).on('change', '.giftNoteCheck', function () {
            var $this = $(this);
            checkGiftNote($this, parent);
            updateButton();
            $('.gift-box--form').find('#sendNoteTo').focus();
            return;
        });
    }

    onChangeFormValues() {
        const to = $('.sendNoteTo').val();
        const from = $('.sendNoteFrom').val();
        const msg = $('.sendNoteMessage').val();
        if (to && from && msg) return true;
        return false;
    }

    onClickSendGiftBox() {
        const parent = this;
        $(document).on('change', '.send-gift-box', function () {
            if (this.checked) {
                // parent.onEnabledGiftBoxOption(false);
                parent.updateGiftButton(false);
                parent.validateHidePriceOption();
                updateButton();
                return;
            }
            updateButton();
            if ($('.giftNoteCheck').is(':checked')) {
                parent.updateGiftButton(false);
                parent.validateHidePriceOption();
                return;
            }
            // parent.onEnabledGiftBoxOption(true);
            // parent.onEnabledCheckBoxValue(false);
            $('.gift-box--note').trigger('change');
            parent.updateGiftButton(true);
            parent.validateHidePriceOption();
            return;
        });
    }

    onChangeFormInputValue() {
        const parent = this;
        $('.sendNoteTo').bind('input propertychange', function () {
            parent.updateButtonOnTrackInput();
        });
        $('.sendNoteFrom').bind('input propertychange', function () {
            parent.updateButtonOnTrackInput();
        });
        $('.sendNoteMessage').bind('input propertychange', function () {
            parent.updateButtonOnTrackInput();
        });
    }

    updateButtonOnTrackInput() {
        if (this.onChangeFormValues()) {
            this.updateGiftButton(false);
            return;
        }
    }

    onEditGidtCard() {
        this.parent = this;
        $(document).on('click', '.btn-edit', function (e) {
            e.preventDefault();
            const $edit = $(this).attr('data-editurl');
            $.ajax({
                url: $edit,
                type: 'GET',
                // dataType: 'json',
                // data: $form.serialize(),
                success: function (data) {
                    const { hidePrice, to, from, giftMessage, updateUrl } = data;
                    $('.gift-box').removeClass('d-none');
                    $('.gift__card').addClass('d-none');
                    handleEditCheck(data);
                    $('.gift-box .gift-box--form, .gift-box .gift-box--note').removeClass('d-none');
                    $('#hidePricePackaging').prop('checked', hidePrice);
                    if ((to && from) || giftMessage) {
                        $('.sendNoteTo').val(to.replace(/[^a-z\s]/gi, ''));
                        $('.sendNoteFrom').val(from.replace(/[^a-z\s]/gi, ''));
                        $('.sendNoteMessage').val(giftMessage);
                    }
                    $('.gift-option-form').attr('action', updateUrl);
                    $('.giftNoteCheck').trigger('change');
                    $.spinner().stop();
                },
                error: function (err) { //eslint-disable-line
                    $.spinner().stop();
                }
            });
        });
    }

    onRemoveGiftCard() {
        const parent = this;
        $(document).on('click', '.gift-btn-remove', function (e) {
            e.preventDefault();
            const $remove = $(this).attr('data-removeurl');
            $.spinner().start();
            $.ajax({
                url: $remove,
                type: 'GET',
                // dataType: 'json',
                // data: $form.serialize(),
                success: function (data) {
                    if (data.isGiftCardRemoved) {
                        $('.gift-box--form, .gift__card').addClass('d-none');
                        $('.gift-box').removeClass('d-none');
                        $('.gift-option-form').trigger('reset');
                        var $this = $('#giftNoteCheck');
                        checkGiftNote($this, parent);
                        updateCartTotals(data.cartModel);
                        validateBasket(data.cartModel);
                        var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
                        var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
                        var cartHeaderCountLabel = data.cartModel.numItems > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
                        $('.cart-header__description', '.shopping-bag').html(DOMPurify.sanitize(cartHeaderCountLabel.replace('{0}', data.cartModel.numItems)));
                        $('.cart-header__description').attr('data-tealiumitemquantity', data.cartModel.numItems);
                        $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.cartModel.cartAnalyticsData, priceAndSize: data.cartModel.checkoutAnalyticsPriceAndSize });
                        cartCustomService.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    }
                    if ($('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    $.spinner().stop();
                },
                error: function (err) { //eslint-disable-line
                    if ($('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    $.spinner().stop();
                }
            });
        });
    }

    giftFormOnSubmit() {
        giftOptionsValidation();
        $(document).on('click', '#buttonGiftUpdate', function () {
            var $form = $(this).closest('.gift-option-form');
            var defer = $.Deferred(); // eslint-disable-line
            if (!$('.giftNoteCheck').is(':checked')) {
                $('input#sendNoteTo, input#sendNoteFrom').removeAttr('required');
            }
            if (!$form.valid()) {
                return defer;
            }
            return defer.resolve().promise();
        });
        $(document).on('submit', '.gift-option-form', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var $form = $(this);
            var giftNoteQueryName = $($form).find('#giftNoteCheck').attr('name');
            var giftBoxChecked = $($form).find('#sendGiftBox').is(':checked');
            var giftNoteChecked = $($form).find('#giftNoteCheck').is(':checked');
            var hidePriceChecked = $($form).find('#hidePricePackaging').is(':checked');
            if (!inputGiftNoteCheck(giftBoxChecked, giftNoteChecked)) {
                // eslint-disable-next-line consistent-return
                return;
            }
            let csrfToken = $('.csrf-token').data('csrf-value');
            $.spinner().start();
            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: $form.serialize() + `&${giftNoteQueryName}=${giftNoteChecked}&csrf_token=${csrfToken}`,
                success: function (data) {
                    $('.gift-box').addClass('d-none');
                    const { editUrl, hidePrice, giftPrice, cartModel, giftBoxImageUrl, sendInGiftBox, giftBoxDimention } = data;
                    handleSubmitCheck(data);
                    $('.gift-price').empty().html(giftPrice);
                    if (giftPrice !== 'Free') {
                        $('.gift-price').removeClass('gift-price-free');
                    }
                    if (hidePrice || hidePriceChecked) {
                        $('._packaging').removeClass('hide');
                    } else {
                        $('._packaging').addClass('hide');
                    }
                    $('#giftBtnEdit').attr('data-editurl', editUrl);
                    $('.gift__card .gift-features').data('editurl', editUrl);
                    if ($('.gift__card-box img.gift-image').length === 0) {
                        var imageHtml = '<img src="" class="gift-image" alt="giftImage" />';
                        $('.gift__card-box div.gift-image-container').append(imageHtml);
                    }
                    if (sendInGiftBox && giftBoxImageUrl.length > 0) {
                        $('.gift__card-box img.gift-image').attr('src', giftBoxImageUrl[0].url + giftBoxDimention.desktop.cart);
                        $('.gift-image-container, .gift-image-container .gift-image').removeClass('d-none');
                    }
                    if (cartModel) {
                        var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
                        var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
                        var cartHeaderCountLabel = cartModel.numItems > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
                        $('.cart-header__description', '.shopping-bag').html(DOMPurify.sanitize(cartHeaderCountLabel.replace('{0}', cartModel.numItems)));
                        updateCartTotals(cartModel);
                        validateBasket(cartModel);
                        $('.cart-header__description').attr('data-tealiumitemquantity', data.cartModel.numItems);
                        cartCustomService.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    }
                    if ($('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    $.spinner().stop();
                    $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.cartModel.cartAnalyticsData, priceAndSize: data.cartModel.checkoutAnalyticsPriceAndSize });
                    tealiumEnable.getAnalyticsData('addGiftBox', data.cartModel);
                },
                error: function (err) { //eslint-disable-line
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    if ($('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    $.spinner().stop();
                }
            });
        });
    }
}
